import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import {
  CandidacyPlacement,
  HttpResponse,
  PlacementQueryParams,
} from "@/types";

export function useGetPlacements({
  jobId,
  queryOptions,
}: {
  jobId: string | undefined;
  queryOptions: PlacementQueryParams;
}) {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["placements", currentCompanyId, jobId, queryOptions],
    queryFn: async () => {
      // TODO: STF-197 - breakout query param types for placement table vs placement tracker table
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { dateAccepted, dateAcceptedFilter, ...rest } = queryOptions;
      const queryParams = misc.prepareQueryParams(rest);

      const path = `companies/${currentCompanyId}/jobs/${jobId ?? ""}/placements?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        CandidacyPlacement[],
        HttpResponse<CandidacyPlacement[]>
      >(path);
      return res.data;
    },
    placeholderData: (previousData) => previousData,
    enabled: !!jobId && !!currentCompanyId,
  });
}
